module.exports = __webpack_public_path__ + "img/ico-grade-green.2fe1bbd8.svg";